import type { ReportSource } from './company';
import service from './index';
import { IReportDetail, ISingleTaskResult } from '@/constants/geo';
import { ETaskSource } from './company';


/** 查询单个运行任务详情 */
export const postRunRecordDetail = (data: { 
  platform?: string;
  id: string;
  pageIndex?: number;
  pageSize?: number;
 }) => service.post<List<ISingleTaskResult>>('/geo/task/run-record/detail', data);

/**
 * 读取公开报表统计，接受与回答详情一致的报告视图来源。
 * @param {{id: string, source?: ETaskSource | ReportSource}} data 报告上下文。
 * @returns {Promise<IReportDetail>} 报告统计数据。
 */
export const postRunRecordStatistics = (data: { id: string, source?: ETaskSource | ReportSource }) => {
  // return new Promise<any>((resolve, reject) => {
  //   resolve({
  //     "total": 14144,
  //     "visibilityCount": 60,
  // "companyName": "郑州三人行锅炉设备有限公司",
  // "keywordsConfig": {
  //   "coreKeywords": [
  //     "锅炉设备经销",
  //     "锅炉设备改造",
  //     "锅炉设备安装",
  //     "锅炉设备维修"
  //   ],
  //   "distillationKeywords": null
  // },
  // "platformMappings": [
  //   {
  //     "platform": "DEEPSEEK",
  //     "name": "DeepSeek",
  //     "defaultCheck": true
  //   },
  //   {
  //     "platform": "DOUBAO",
  //     "name": "字节豆包",
  //     "defaultCheck": true
  //   },
  //   {
  //     "platform": "YUANBAO",
  //     "name": "腾讯元宝",
  //     "defaultCheck": true
  //   },
  //   {
  //     "platform": "YIYAN",
  //     "name": "百度文小言",
  //     "defaultCheck": true
  //   },
  //   {
  //     "platform": "KIMI",
  //     "name": "Kimi",
  //     "defaultCheck": true
  //   },
  //   {
  //     "platform": "TONGYI2",
  //     "name": "通义千问",
  //     "defaultCheck": true
  //   }
  // ],
  // "aiVisibility": {
  //   "visible": 1248,
  //   "expand": 13520,
  //   "total": 1428
  // },
  // "createTime": "2026-01-12T12:02:39",
  // "updateTime": "2026-01-12T12:02:39",
  // "aiVisibilityPlatformData": {
  //   "DOUBAO": {
  //     "visible": 240,
  //     "expand": 2320,
  //     "total": 264
  //   },
  //   "YIYAN": {
  //     "visible": 250,
  //     "expand": 2320,
  //     "total": 264
  //   },
  //   "YUANBAO": {
  //     "visible": 202,
  //     "expand": 2080,
  //     "total": 264
  //   },
  //   "TONGYI2": {
  //     "visible": 108,
  //     "expand": 2160,
  //     "total": 108
  //   },
  //   "DEEPSEEK": {
  //     "visible": 200,
  //     "expand": 2320,
  //     "total": 264
  //   },
  //   "KIMI": {
  //     "visible": 248,
  //     "expand": 2320,
  //     "total": 264
  //   }
  // },
  // "aiInclination": {
  //   "positive": 1246,
  //   "positiveExpand": 13520,
  //   "neutral": 2,
  //   "neutralExpand": 0,
  //   "negative": 0,
  //   "negativeExpand": 0
  // },
  // "aiInclinationPlatformData": {
  //   "DOUBAO": {
  //     "positive": 239,
  //     "positiveExpand": 2320,
  //     "neutral": 1,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   },
  //   "YIYAN": {
  //     "positive": 249,
  //     "positiveExpand": 2320,
  //     "neutral": 1,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   },
  //   "YUANBAO": {
  //     "positive": 202,
  //     "positiveExpand": 2080,
  //     "neutral": 0,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   },
  //   "TONGYI2": {
  //     "positive": 108,
  //     "positiveExpand": 2160,
  //     "neutral": 0,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   },
  //   "DEEPSEEK": {
  //     "positive": 200,
  //     "positiveExpand": 2320,
  //     "neutral": 0,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   },
  //   "KIMI": {
  //     "positive": 248,
  //     "positiveExpand": 2320,
  //     "neutral": 0,
  //     "neutralExpand": 0,
  //     "negative": 0,
  //     "negativeExpand": 0
  //   }
  // },
  // "competitor": {
  //   "brand": 1248,
  //   "items": [
  //     {
  //       "name": "本品牌",
  //       "count": 1248
  //     },
  //     {
  //       "name": "郑州郑锅安装工程",
  //       "count": 366
  //     },
  //     {
  //       "name": "河南热丰锅炉集团",
  //       "count": 328
  //     },
  //     {
  //       "name": "河南安信热能科技",
  //       "count": 214
  //     },
  //     {
  //       "name": "其他品牌",
  //       "count": 1527
  //     }
  //   ],
  //   "total": 3683
  // },
  // "competitorPlatformData": {
  //   "DOUBAO": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 240
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 47
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 40
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 102
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 417
  //       }
  //     ],
  //     "total": 846
  //   },
  //   "YIYAN": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 250
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 23
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 29
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 0
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 319
  //       }
  //     ],
  //     "total": 621
  //   },
  //   "YUANBAO": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 202
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 69
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 47
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 1
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 515
  //       }
  //     ],
  //     "total": 834
  //   },
  //   "TONGYI2": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 108
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 39
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 46
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 39
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 218
  //       }
  //     ],
  //     "total": 450
  //   },
  //   "DEEPSEEK": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 200
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 105
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 67
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 0
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 457
  //       }
  //     ],
  //     "total": 829
  //   },
  //   "KIMI": {
  //     "brand": 0,
  //     "items": [
  //       {
  //         "name": "本品牌",
  //         "count": 248
  //       },
  //       {
  //         "name": "郑州郑锅安装工程",
  //         "count": 83
  //       },
  //       {
  //         "name": "河南热丰锅炉集团",
  //         "count": 99
  //       },
  //       {
  //         "name": "河南安信热能科技",
  //         "count": 72
  //       },
  //       {
  //         "name": "其他品牌",
  //         "count": 302
  //       }
  //     ],
  //     "total": 804
  //   }
  // },
  //   })
  // });
  return service.post<IReportDetail>('/geo/task/run-record/analysis-detail', data)};

/** 修改统计数据结果 */
export const postEditRunRecordStatistics = (data: { id: string; result: IReportDetail }) =>
  service.post<string>('/geo/task/run-record/update-analysis-result', data);

export enum PageType {
  Report = 'REPORT',
}
/**
 * TemplatePageItem
 */
export interface TemplatePageItem {
  companyName?: string;
  logoUrl?: string;
  pageType?: PageType;
  templateId: string;
  endpoint?: string;
  [property: string]: any;
}
/** 获取报表看板模板列表 */
export const getTemplateList = (data: { pageIndex: number; pageSize: number; pageType: string }) =>
  service.post<List<TemplatePageItem>>('/setting/template/page', data);

/**
 * ReportWebTemplateRes，报表模板响应参数
 */
export interface ReportWebTemplateRes {
  /**
   * 背景图片
   */
  backgroundImage?: string;
  /**
   * 企业名称
   */
  companyName?: string;
  /**
   * 前景图片
   */
  foregroundImage?: string;
  /**
   * 模板id
   */
  id?: string;
  /**
   * logo 图标地址
   */
  logoUrl?: string;
  /**
   * 产品名称
   */
  productName?: string;
  [property: string]: any;
}
/** 获取报表看板模板配置 */
export const getTemplateConfig = (templateId: string) =>
  service.get<ReportWebTemplateRes>('/setting/report', {
    params: { templateId },
  });